import dynamic from 'next/dynamic';

import { useViewer } from '@vimeo/viewer';

const Footer = dynamic(
  async () => {
    const { Footer } = await import('@vimeo/footer');
    return Footer;
  },
  {
    ssr: false,
  },
);

const Legal = dynamic(
  async () => {
    const {
      Footer: { Legal },
    } = await import('@vimeo/footer');
    return Legal;
  },
  {
    ssr: false,
  },
);

export const FooterModule = () => {
  const viewer = useViewer();

  const impressumQualifies = viewer?.impressumQualifies ?? false;
  const terminateContractQualifies = viewer?.terminateContractQualifies ?? false;

  return (
    <Footer>
      <Legal
        impressumQualifies={impressumQualifies}
        terminateContractQualifies={terminateContractQualifies}
      />
    </Footer>
  );
};
